var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"sm-notification__inner"},[_c('include-svg',{attrs:{"name":'icon-warning'}}),_c('span',[_vm._v("Your account is inactive, Please contact your master account.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }